import { Button, ButtonLink, Stack } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  isSubmitDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const CreateBranchFormPresentation: React.FC<Props> = ({ isSubmitDisabled, onSubmit }) => (
  <form onSubmit={onSubmit} className={styles.form}>
    <Stack direction='column' gap={24}>
      <h2 className={styles.formTitle}>事業所の新規追加</h2>
      <div className={styles.formContainer}>
        <Stack direction='column' gap={24}>
          <TextInputFieldController
            name='name'
            fieldWrapperProps={{
              labelText: '事業所名',
            }}
            textInput={{
              placeholder: '事業所名を入力してください',
            }}
          />
          <TextInputFieldController
            name='code'
            fieldWrapperProps={{
              labelText: '事業所コード',
              helperText: '英数字のみ使用可能。',
            }}
            textInput={{
              placeholder: '入力してください',
            }}
          />
        </Stack>
      </div>
      <Stack direction='row' gap={8}>
        <ButtonLink to={ROUTES.BRANCHES.INDEX} variant='secondary'>
          キャンセル
        </ButtonLink>
        <Button type='submit' disabled={isSubmitDisabled}>
          追加
        </Button>
      </Stack>
    </Stack>
  </form>
);
